import {Sprite} from 'pixi.js';
import {PieMenuItems} from './pie_menu/PieMenuItems';
import {PieMenuCenter} from './pie_menu/PieMenuCenter';
import {StaticData} from '../../../data/StaticData';
import {PieMenuItemEvents} from './pie_menu/pie_menu_item/pie_menu_item/PieMenuItemEvents';
import {Stack} from '../game_table/table_objects/stacks/Stack';
import {StackSelector} from '../../../controllers/StackSelector';
import {Card} from '../game_table/table_objects/stacks/Card';
import {CommandsStrategiesController} from './pie_menu/CommandsStrategiesController';
import {CommandStrategy, SubmenuType} from './pie_menu/pie_menu_commands/base/CommandStarategy';
import {CardSelector} from '../../../controllers/CardSelector';
import {DynamicData} from '../../../data/DynamicData';

export class PieMenu extends Sprite
{
    private readonly center: PieMenuCenter;
    private readonly itemsTier1: PieMenuItems;
    private readonly itemsTier2: PieMenuItems;

    private onPieMenuItemPointerOverBindThis: (e: Event) => void;
    private onPieMenuItemPointerOutBindThis: (e: Event) => void;
    private onPieMenuItemPointerDownBindThis: (e: Event) => void;
    private hoverStack: Stack | undefined;
    private hoverCard: Card | undefined;

    constructor() {
        super();

        this.center = new PieMenuCenter(StaticData.pieMenuCenterRadius);
        this.itemsTier1 = new PieMenuItems(55, 105, 0);
        this.itemsTier2 = new PieMenuItems(110, 142, 0, 20);

        this.addChild(this.center).visible = false;
        this.addChild(this.itemsTier1);
        this.addChild(this.itemsTier2);

        this.onPieMenuItemPointerOverBindThis = this.onPieMenuItemPointerOver.bind(this);
        this.onPieMenuItemPointerOutBindThis = this.onPieMenuItemPointerOut.bind(this);
        this.onPieMenuItemPointerDownBindThis = this.onPieMenuItemPointerDown.bind(this);

        addEventListener(PieMenuItemEvents.ON_PIE_MENU_POINTER_OVER, this.onPieMenuItemPointerOverBindThis);
        addEventListener(PieMenuItemEvents.ON_PIE_MENU_POINTER_OUT, this.onPieMenuItemPointerOutBindThis);
        addEventListener(PieMenuItemEvents.ON_PIE_MENU_POINTER_DOWN, this.onPieMenuItemPointerDownBindThis);
    }

    /**
     * Очищаем меню
     */
    clearItems(): void {
        this.center.clear();
        this.itemsTier1 && this.itemsTier1.clearItems();
        this.itemsTier2 && this.itemsTier2.clearItems();
    }

    /**
     * Уничтожение
     */
    destroy(): void {
        removeEventListener(PieMenuItemEvents.ON_PIE_MENU_POINTER_OVER, this.onPieMenuItemPointerOverBindThis);
        removeEventListener(PieMenuItemEvents.ON_PIE_MENU_POINTER_OUT, this.onPieMenuItemPointerOutBindThis);
        removeEventListener(PieMenuItemEvents.ON_PIE_MENU_POINTER_DOWN, this.onPieMenuItemPointerDownBindThis);

        delete this.onPieMenuItemPointerOverBindThis;
        delete this.onPieMenuItemPointerOutBindThis;
        delete this.onPieMenuItemPointerDownBindThis;

        super.destroy({children: true});
    }

    /**
     * Запомнить карты для последующего применения команды меню
     * @param stacks - массив колод
     */
    applyCard(card: Card) {
        if (!DynamicData.settings.canViewTableMenu) {
            return;
        }
        this.hoverCard = card;
        this.hoverStack = undefined;
        this.drawCommands();
    }

    /**
     * Запомнить колодe для последующего применения команды меню
     * @param stack - запоминаема колода
     */
    applyStack(stack: Stack) {
        if (!DynamicData.settings.canViewTableMenu) {
            return;
        }
        this.hoverStack = stack;
        this.hoverCard = undefined;
        this.drawCommands();
    }

    private drawCommands(): void {
        let commandStrategies: CommandStrategy[] = CommandsStrategiesController.getStrategies(this.hoverCard, this.hoverStack);
        if (!commandStrategies.length) {
            return;
        }
        this.center.visible = true;
        this.itemsTier1.drawItems(0, commandStrategies);
    }

    /**
     * Обработчик события pointerover
     * @param e Событие взаимодейтсвия пользователя
     */
    private onPieMenuItemPointerOver(e: Event): void {
        let data: {strategy: CommandStrategy, startCorner: number, isTier2: boolean} = (e as MessageEvent).data;
        this.center.setHintText(data.strategy.command.hint);
        data.isTier2 || this.itemsTier2.clearItems();
        if (!data.strategy.command.hasSubmenu || data.isTier2) {
            return;
        }

        //если меню открыли, а противник вышел
        if (!data.isTier2 &&
            data.strategy.command.hasSubmenu &&
            data.strategy.command.submenuType == SubmenuType.PLAYER &&
            data.strategy.getTier2CommandsCount() == 0
        ) {
            return;
        }

        this.itemsTier2.drawItems(data.startCorner, [data.strategy], data.strategy.getTier2CommandsCount());
    }

    /**
     * Обработчик события pointerout
     * @param e Событие взаимодейтсвия пользователя
     */
    private onPieMenuItemPointerOut(e: Event): void {
        let data: {strategy: CommandStrategy, startCorner: number, isTier2: boolean} = (e as MessageEvent).data;
        if (!data.strategy.command) {
            return;
        }
        let tier2PlayerAlone: boolean = !data.isTier2 && data.strategy.command.submenuType == SubmenuType.PLAYER && data.strategy.getTier2CommandsCount() == 1;
        tier2PlayerAlone && this.itemsTier2.pointerOutTier2PlayerAlone();
    }

    /**
     * Обработчик события pointerdown
     * @param e Событие взаимодейтсвия пользователя
     */
    private onPieMenuItemPointerDown(e: Event): void {
        let data: {strategy: CommandStrategy, commandIndex: number, isTier2: boolean} = (e as MessageEvent).data;
        if (!data.strategy.command) {
            return;
        }

        data.strategy.execute(data.commandIndex);
        StackSelector.unselectAll();
        CardSelector.unselectAll();
    }
}
